export default {
  // undefined until getMe returns. filterMenuItems treats unknown as
  // "not allowed", so the gap is safe.
  userLogin: null,
  processing: false,
  error: null,
  success: null,
};
